import { createFileRoute } from '@tanstack/react-router'
import { SettingsEmailAccount } from '@/features/settings/email-account'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsEmailAccount,
})
